<template>
  <div>
    <via-nav-bar
      title="编辑文档"
      @click-left="$router.$back()"
    >
      <div
        slot="right"
        class="nav-right"
        @click="confirm"
      >保存</div>
    </via-nav-bar>
    <div class="page">
      <!-- markdown解析器 -->
      <mavon-editor
        ref="md"
        v-model="markdown.content"
        :style="{ height: $vw(editorHeight)}"
        class="md-edit md-pink"
        :subfield="markdown.subfield"
        :default-open="markdown.defaultOpen"
        :toolbars-flag="markdown.toolbarsFlag"
        :box-shadow="markdown.boxShadow"
        :code-style="markdown.codeStyle"
        :editable="markdown.editable"
        :scroll-style="markdown.scrollStyle"
        autofocus
        :toolbars="markdown.toolbars"
        placeholder="markdown语法编辑...不会右上角问号有教程"
        @imgAdd="imgAdd"
      />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { initDocumentListen } from '~/utils/func/index.js'

export default {
  name: 'DocEdit',
  data() {
    return {
      markdown: {
        content: '',
        subfield: false, // 单双栏模式
        defaultOpen: 'edit', // edit： 默认展示编辑区域 ， preview： 默认展示预览区域
        boxShadow: false,
        codeStyle: 'vs2015',
        editable: true,
        toolbarsFlag: true,
        scrollStyle: true,
        toolbars: {
          bold: true, // 粗体
          italic: true, // 斜体
          header: true, // 标题
          underline: true, // 下划线
          strikethrough: true, // 中划线
          mark: true, // 标记
          superscript: false, // 上角标
          subscript: false, // 下角标
          quote: true, // 引用
          ol: true, // 有序列表
          ul: true, // 无序列表
          link: true, // 链接
          imagelink: true, // 图片链接
          code: true, // code
          table: true, // 表格
          fullscreen: true, // 全屏编辑
          readmodel: false, // 沉浸式阅读
          htmlcode: false, // 展示html源码
          help: true, // 帮助
          undo: true, // 上一步
          redo: true, // 下一步
          trash: true, // 清空
          save: false, // 保存（触发events中的save事件）
          navigation: false, // 导航目录
          alignleft: true, // 左对齐
          aligncenter: true, // 居中
          alignright: true, // 右对齐
          subfield: false, // 单双栏模式
          preview: true // 预览
        }
      }
    }
  },
  computed: {
    // rpx
    editorHeight() {
      return this.$pxToRpx(this.$clientHeight) - 46
    }
  },
  activated() {
    this.initData()
  },
  deactivated() {
    // 移除监听
    document.removeEventListener('click', window.listenDocument, true)
  },
  methods: {
    initData() {
      // 初始化监听回调
      initDocumentListen()
      document.addEventListener('click', window.listenDocument, true)

      const data = this.$store.getters['docEdit/data']
      const key = this.$route.params.storeKey || 'default'
      if (data[key]) {
        const doc = data[key]
        this.markdown.content = doc
      }
    },
    // 上传图片
    imgAdd(pos, $file) {
      console.log($file)
      const md = this.$refs.md
      const formdata = new FormData()
      formdata.append('smfile', $file)
      axios({
        url: 'https://cors-anywhere.herokuapp.com/https://sm.ms/api/upload',
        method: 'post',
        data: formdata,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        // 将返回的url替换到文本原位置![...](0) -> ![...](url)
        this.$toast.success('图片上传成功')
        md.$img2Url(pos, res.data.data.url)
      }).catch(() => {
        this.$toast.fail('图片上传失败')
      })
    },
    confirm() {
      if (!this.markdown.content) {
        this.$toast.fail('你啥都还没写')
        return
      }
      if (this.markdown.content.length > 65534) {
        this.$toast.fail(`太多字了，你需要删掉${this.markdown.content.length - 65534}个字符`)
        return
      }
      const key = this.$route.params.storeKey || 'default'
      const doc = this.markdown.content
      this.$store.commit('docEdit/updateData', { ...this.$store.getters['docEdit/data'], [key]: doc })
      this.$router.$back()
    }
  }
}
</script>

<style scoped>
.nav-right {
  color: var(--themeColor)
}
.page {
  width: 375px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.md-edit {
  width: 375px;
}
</style>
<style>
@import '../../static/css/markdown-theme-pink.css';
.md-edit .v-note-op {
  border: none !important;
}
.md-edit .auto-textarea-block {
  max-width: 325px;
}
</style>
